import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { followUpPopupKey, type FollowUpList } from "../shared/followup";
import { EvaluationBadge } from "./pages/followup";

const TOP = 3;

function seen(key: string): boolean {
  try {
    return window.localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}

function remember(key: string): void {
  try {
    window.localStorage.setItem(key, "1");
  } catch {
    /* private mode: the panel simply shows again next load */
  }
}

/** Once per user per Athens day, on the first load that has something due. Dismissed with ✕ or by opening the page. */
export function FollowUpPopup({ userId, list }: { userId: string; list: FollowUpList }) {
  const key = followUpPopupKey(userId, list.today);
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (list.count > 0 && !seen(key) && location.pathname !== "/followup") {
      remember(key);
      setOpen(true);
    }
    // Only the first list of the day decides; navigation does not re-open it.
  }, [key, list.count > 0]);

  if (!open) return null;
  const top = list.due.slice(0, TOP);
  return (
    <aside className="fu-popup" role="status" aria-live="polite">
      <button type="button" className="fu-popup-close" aria-label="Κλείσιμο" onClick={() => setOpen(false)}>✕</button>
      <strong>{list.count} follow-up σήμερα</strong>
      <ul>
        {top.map((item) => (
          <li key={item.id}>
            <EvaluationBadge code={item.evaluation} /> {item.name}
            {item.overdue_days > 0 ? <span className="fu-due late"> · καθυστερεί {item.overdue_days} {item.overdue_days === 1 ? "μέρα" : "μέρες"}</span> : null}
          </li>
        ))}
        {list.count > TOP ? <li className="muted">και {list.count - TOP} ακόμη…</li> : null}
      </ul>
      <Link className="button" to="/followup" onClick={() => setOpen(false)}>Ανοιγμα Follow-up</Link>
    </aside>
  );
}
